import React from 'react';
import { motion } from 'framer-motion';
import { HiOutlineAcademicCap, HiOutlineBookOpen, HiOutlineClipboardList } from 'react-icons/hi';

const CoursesHero = () => {
  return (
    <div className="relative w-full h-[40vh] sm:h-[45vh] md:h-[50vh] lg:h-[55vh] overflow-hidden">
      {/* Background Image with Parallax */}
      <motion.div
        initial={{ scale: 1.2 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.5 }}
        className="absolute inset-0"
      >
        <img
          src="/assets/coursebanner.png"
          alt="Course Banner"
          className="w-full h-full object-cover"
        />
      </motion.div>

      {/* Light Gradient Overlay - Gray */}
      <div className="absolute inset-0 bg-gradient-to-r from-gray-800/90 via-gray-700/80 to-gray-900/90" />
      
      {/* Animated Background Elements - Light Gray */}
      <motion.div 
        className="absolute top-20 left-10 text-gray-300/30 hidden lg:block"
        animate={{
          y: [0, -20, 0],
          rotate: [0, 10, -10, 0]
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          repeatType: "reverse"
        }}
      >
        <HiOutlineAcademicCap size={80} />
      </motion.div>

      <motion.div 
        className="absolute bottom-20 right-10 text-gray-300/30 hidden lg:block"
        animate={{
          y: [0, 20, 0],
          rotate: [0, -10, 10, 0]
        }}
        transition={{
          duration: 10,
          repeat: Infinity,
          repeatType: "reverse"
        }}
      >
        <HiOutlineBookOpen size={70} />
      </motion.div>

      <motion.div 
        className="absolute top-40 right-40 text-gray-300/30 hidden lg:block"
        animate={{
          scale: [1, 1.2, 1],
          opacity: [0.2, 0.3, 0.2]
        }}
        transition={{
          duration: 6,
          repeat: Infinity,
          repeatType: "reverse"
        }}
      >
        <HiOutlineClipboardList size={60} />
      </motion.div>

      {/* Hero Content */}
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 sm:px-6">
        <motion.h1 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 text-white drop-shadow-2xl"
        >
          Postgraduate Course Details
        </motion.h1>
        
        <motion.p 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="text-sm sm:text-base md:text-lg max-w-2xl px-4 text-gray-200 leading-relaxed drop-shadow-lg"
        >
          Explore comprehensive postgraduate course information, curriculum, and learning outcomes
        </motion.p>

        {/* Scroll Indicator */}
        <motion.div 
          className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          <div className="w-6 h-10 border-2 border-gray-300/30 rounded-full flex justify-center backdrop-blur-sm">
            <div className="w-1 h-2 bg-gray-300/50 rounded-full mt-2" />
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default CoursesHero;